<template>
  <div>
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>测试管理</span>
      </div>
      <div>
        <div class="mr-t15 flex flex-row-between">
          <div>
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
              <el-form-item label="标题">
                <el-input v-model="searchForm.title" placeholder="請輸入"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="doSearch">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button @click="doReset">重置</el-button>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="showCreate" v-has="'addTest'"><i class="el-icon-plus"></i>新增</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="mr-t15">
          <el-table v-loading="loading" :border="true" :data="dataList" :header-cell-style="headerStyle"
            style="width: 100%">
            <el-table-column prop="title" label="标题" align="center">
            </el-table-column>
            <el-table-column prop="path" label="单图" width="100" align="center">
              <template slot-scope="scope">
                <el-image :src="$api.imagePath  + scope.row.image" style="width: 50px; height: 50px"
                  :preview-src-list="[$api.imagePath  + scope.row.image]"></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="images" label="多图" width="500" align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.images">
                  <el-image v-for="(item,index) in (scope.row.images)" :src="$api.imagePath + item"
                    :key="index" style="width: 50px; height: 50px"
                    :preview-src-list="[$api.imagePath  + item]"></el-image>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="status" label="狀態" width="130">
              <template slot-scope="scope">
                <el-switch @change="statusChange(scope.row)" v-model="scope.row.status" :active-value="1"
                  :inactive-value="0"></el-switch>
              </template>
            </el-table-column>
            <el-table-column prop="createAt" label="創建時間" align="center" width="200"></el-table-column>
            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="scope">
                <div class="flex flex-row-center">
                  <div>
                    <el-link type="primary" @click="edit(scope.row)"  v-has="'editTest'">修改</el-link>
                  </div>
                  <div class="mr-l15">
                    <el-link type="primary" @click="del(scope.row)" v-has="'delTest'">删除</el-link>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="mr-t20 flex flex-row-end">
          <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10,20,40,50,60,80,100]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="dataObj.total">
          </el-pagination>
        </div>

        <!-- 新增-->
        <CreateModal @ok="createOk" ref="CreateModal"></CreateModal>
        <!-- 修改 -->
        <EditModal @ok="editOk" ref="editModal"></EditModal>
      </div>
    </el-card>
  </div>
</template>

<script>
  import CreateModal from "@/views/settings/test/createModal"
  import EditModal from "@/views/settings/test/editModal"
  export default {
    name: "RuleList",
    components: {
      CreateModal,
      EditModal,
    },
    data() {
      return {
        loading: true,
        headerStyle: {
          'background': '#f9f9f9',
          'color': '#666'
        },
        searchForm: {
          title: "",
        },
        dataList: [],
        dataObj: {},
        currentPage: 1,
        pageSize: 10,
      }
    },
    created() {
      this.getList();
    },
    methods: {
      //切换页码
      handleCurrentChange(e) {
        this.currentPage = e;
        this.getList();
      },
      // 页码大小改变
      handleSizeChange(e) {
        this.pageSize = e;
        this.getList();
      },
      // 搜索
      doSearch() {
        this.getList();
      },
      //重置搜索
      doReset() {
        this.resetGetList();
      },
      //重置搜索条件查询
      resetGetList() {
        this.searchForm = {
          title: ""
        }
        this.currentPage = 1;
        this.pageSize = 10;
        this.getList();
      },
      //显示新增dialog
      showCreate() {
        this.$refs.CreateModal['visible'] = true;
      },
      //传值并且打开修改dialog
      edit(row) {
        this.$refs.editModal.getData(row);
        this.$refs.editModal['visible'] = true
      },
      //改变狀態
      statusChange(row) {
        this.$request({
          url: this.$api.test.updateStatus,
          method: "post",
          data: {
            id: row.id,
            status: row.status
          }
        }).then((res) => {
          if (res.data.code == 1) {
            this.$message.success(res.data.msg)
          } else {
            this.$message.error(res.data.msg)
          }
        }).catch(() => {
          this.$message.error("请求失败");
        })
      },
      createOk() {
        this.getList();
      },
      editOk() {
        this.getList();
      },
      //删除
      del(row) {
        this.$confirm('此操作將永久刪除，是否繼續?', '提示', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$request({
            url: this.$api.test.del,
            method: "post",
            data: {
              id: row.id
            }
          }).then((res) => {
            if (res.data.code == 1) {
              this.$message.success(res.data.msg);
              this.getList();
            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(() => {
            this.$message.error("请求失败");
          })
        }).catch(() => {

        });
      },
      //获取列表
      getList() {
        this.loading = true;
        this.$request({
          url: this.$api.test.testList,
          data: {
            page: this.currentPage,
            pageSize: this.pageSize,
            title: this.searchForm.title
          }
        }).then((res) => {
          this.dataObj = res.data.data;
          this.dataList = res.data.data.data;
          this.loading = false;
        }).catch(() => {
          this.$message.error("获取列表失败");
        })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/settings/test/TestList.vue